import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { CustomerService } from '../customers.service';
import { Customer } from '../customers';
import { Observable, empty, forkJoin } from 'rxjs';
import { map, debounceTime, finalize, switchMap, tap, startWith, filter } from 'rxjs/operators';
import { API, APIDefinition, Columns, Config, DefaultConfig } from 'ngx-easy-table';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { Contact } from '../../contacts/contact';
import { faEdit,  faBan, faPlusSquare } from '@fortawesome/free-solid-svg-icons';
import { MessagerComponent } from '../../messager/messager/messager.component';
import { ContactsService } from '../../contacts/contacts.service';
import { GridDeleteComponent } from '../../utils/grid-delete-component';
import { AuthService } from '../../auth.service';
import { LoggingService } from '../../utils/logging.service';
import { GlobalEmailService } from '../../utils/globalemail.service';
import { io } from 'socket.io-client';
import { environment } from 'src/environments/environment';
import { LocationService } from 'src/app/location/location.service';
import { AdditionalworkComponent } from 'src/app/additionalwork/additionalwork.component';
import { EmployeeService } from 'src/app/employee/employee.service';



//

@Component({
  selector: 'app-edit-customers',
  templateUrl: './edit-customer-dialog.html',
  styleUrls: ['./customers.component.css']
})

export class EditCustomerDialogComponent implements OnInit {
  accountRep: any;
  accountManager: any;
  hersModeler: any;
  hersModeler$: Observable<any>;
  constructor(public dialogRef: MatDialogRef<EditCustomerDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: Customer, private fb:FormBuilder,public employeeService: EmployeeService, public locService: LocationService, public customerService: CustomerService, private messager: MessagerComponent, public contactService: ContactsService, public log: LoggingService, public ges: GlobalEmailService) {}

  @ViewChild('refname', {read: false, static: false})
  refNameInputRef: ElementRef;
  mode = this.data.mode;
  contact$ : Observable<Contact[]>;
  isLoading = false;
  initialCustomerName = this.data.customer_name; // for the name-change email

  employee$: Observable<any[]>;
  manager$: Observable<any[]>;


  customerForm = new FormGroup({
    customer_name : new FormControl(this.data.customer_name || ''),
    office_street_address : new FormControl(this.data.office_street_address || ''),
    office_city : new FormControl(this.data.office_city || ''),
    office_state : new FormControl(this.data.office_state || ''),
    planroom_web_address : new FormControl(this.data.planroom_web_address || ''),
    planroom_username_login : new FormControl(this.data.planroom_username_login || ''),
    certificates_go_to : new FormControl(this.data.certificates_go_to || ''),
    customer_note : new FormControl(this.data.customer_note || ''),
    needsplanrev : new FormControl(this.data.needsplanrev || false),
    inactivecustomer : new FormControl(this.data.inactivecustomer || false),
    region : new FormControl(this.data.region || ''),
    office_zip : new FormControl(this.data.office_zip || ''),
    customer_type : new FormControl(this.data.customer_type || ''),
    dsecuritygroup : new FormControl(this.data.dsecuritygroup || ''),
    dsalesman : new FormControl(this.data.dsalesman || ''),
    ratercompid : new FormControl(this.data.ratercompid || ''),
    folderlocation : new FormControl(this.data.folderlocation || ''),
    qad_id : new FormControl(this.data.qad_id || ''),
    designeremail : new FormControl(this.data.designeremail || ''),
    licenseno : new FormControl(this.data.licenseno || ''),
    billing_notes : new FormControl(this.data.billing_notes || ''),
    referral : new FormControl(this.data.referral || ''),
    codecomp : new FormControl(this.data.codecomp || ''),
    customurl : new FormControl(this.data.customurl || ''),
    startscoord : new FormControl(this.data.startscoord || ''),
    billcontact : new FormControl(this.data.billcontact || ''),
    purchasing : new FormControl(this.data.purchasing || ''),
    refpaid : new FormControl(this.data.refpaid || false),
    welcome : new FormControl(this.data.welcome || false),
    creferral : new FormControl(this.data.creferral || ''),
    planpath : new FormControl(this.data.planpath || ''),
    sendrevcon : new FormControl(this.data.sendrevcon || ''),
    billing_type : new FormControl(this.data.billing_type || ''),
    paymenthold : new FormControl(this.data.paymenthold || false),
    inv_delivery_mtd : new FormControl(this.data.inv_delivery_mtd || ''),
    pmt_recon_mtd : new FormControl(this.data.pmt_recon_mtd || ''),
    po_system: new FormControl(this.data.po_system || ''),
    accounting_rep: new FormControl(this.data.accounting_rep || 0),
    account_manager: new FormControl(this.data.account_manager || 0),
    hers_modeler: new FormControl(this.data.hers_modeler || 0),
    doc_url: new FormControl(this.data.doc_url || ''),
    registry_name: new FormControl(this.data.registry_name || ''),
    reviewer: new FormControl(this.data.reviewer || ''), 
    tier : new FormControl(this.data.tier || ''),
    modeling : new FormControl(false)
  });

  ngOnInit() {

    //pre-fill dropdowns here
      this.contact$ = this.customerForm.get('creferral').valueChanges.pipe(
      debounceTime(400),
      tap(value => {
        this.isLoading = true;
      }),
      switchMap(value =>
        value.length > 0 ? this.contactService.getContactsDropdown(value as string) : empty()
        .pipe(
          finalize(() => this.isLoading = false)
          )
      )
    );


    this.employee$ = this.customerForm.get('accounting_rep').valueChanges.pipe(
      debounceTime(400),
      tap(() => this.isLoading = true ),
      switchMap(value =>
        value.length > 0 ? this.locService.getEmployeesDropdown(value as string) : empty()
        .pipe(
          tap((res) => {
            this.isLoading = false;
          }),
          finalize(() => this.isLoading = false)
          )
      )
    );

    this.manager$ = this.customerForm.get('account_manager').valueChanges.pipe(
      debounceTime(400),
      tap(() => this.isLoading = true ),
      switchMap(value =>
        value.length > 0 ? this.locService.getEmployeesDropdown(value as string) : empty()
        .pipe(
          tap((res) => {
            this.isLoading = false;
          }),
          finalize(() => this.isLoading = false)
          )
      )
    );

    this.hersModeler$ = this.customerForm.get('hers_modeler').valueChanges.pipe(
      debounceTime(400),
      tap(() => this.isLoading = true ),
      switchMap(value =>
        value.length > 0 ? this.locService.getEmployeesDropdown(value as string) : empty()
        .pipe(
          tap((res) => {
            this.isLoading = false;
          }),
          finalize(() => this.isLoading = false)
          )
      )
    );


    //load our employee info
      forkJoin({
        accountRep: this.employeeService.getOneEmployee(this.data.accounting_rep),
        accountManager: this.employeeService.getOneEmployee(this.data.account_manager),
        hersModeler: this.employeeService.getOneEmployee(this.data.hers_modeler)
      }).subscribe({
        next: (results) => {
          this.accountRep = results.accountRep.employee_name;
          this.accountManager = results.accountManager.employee_name;
          this.hersModeler = results.hersModeler.employee_name;
        } 
      });


  }


  displayFunctionEmp(employee: any) {
    if (employee) { return employee.employee_name; }
  }

  onSelectAccountRep(obj: any){

    this.accountRep = obj.employee_name;
    this.customerForm.get('accounting_rep').setValue(obj.employee_id);

  }

  onSelectAccountManager(obj: any){

    this.accountManager = obj.employee_name;
    this.customerForm.get('account_manager').setValue(obj.employee_id);

  }

  onSelectHersModeler(obj: any){

    this.hersModeler = obj.employee_name;
    this.customerForm.get('hers_modeler').setValue(obj.employee_id);

  }

  getStatusText(): string {
    return this.data.inactivecustomer ?  'Inactive' : 'Active'
  }

  inactiveToggle(): void {
    this.data.inactivecustomer = !this.data.inactivecustomer;

    this.customerForm.get('inactivecustomer').setValue(this.data.inactivecustomer);

  }

  onSelectContact(contact: Contact): void {
    this.data.creferral = contact.id;
    this.customerForm.get('creferral').setValue(contact.id);
    this.refNameInputRef.nativeElement.value = contact.id;
  }



  displayFunction(contact: Contact){
    if (contact) { return contact.customer_name; }
}

  save(): void {
      let changedProperties = [];
      Object.keys(this.customerForm.controls).forEach((name) => {
            const currentControl = this.customerForm.controls[name];

            if (currentControl.dirty) {
              changedProperties.push(name +': ' + this.customerForm.controls[name].value);
            }
      });

    this.customerService.saveEdit(this.data.customer_id, this.customerForm.value).subscribe(
      res => {
        this.log.info(this.data.usernamee + ' saved the following edits to customer ' + this.data.customer_name.trim() + ' {' + changedProperties.toString() + '}' );
        this.dialogRef.close();
        
        changedProperties.forEach((element) => {
          if(element.includes('customer_name')){
            this.customerService.sendCustomerEmail(this.customerForm.get('customer_name').value, this.data.usernamee,`"${this.initialCustomerName}" name update`).subscribe(
              res=> {
              }
            );
          }
        });

      },
      err => {
        this.log.error(this.data.usernamee + ' encountered an error editing customer : Submitted data: ' + '{' + this.customerForm.value.toString() + '} ' + err.toString() );
      }
    );

  }

  add(): void {
    this.customerService.addCustomer(this.customerForm.value).subscribe(
      res => {
        this.dialogRef.close();
        this.customerService.sendCustomerEmail(this.customerForm.get('customer_name').value, this.data.usernamee,'added').subscribe(
          res=> {
          }
        );

        this.log.info(this.data.usernamee + ' created a customer: ' + this.customerForm.value.customer_name.trim() );

        if(res.Error){

          let errMessage = res.Message;

          this.messager.openSnackBar('Error saving customer, an email with all data has been sent to support.', '[close]', 'errorAlert');

          this.ges.sendDebugEmail('IMPORTANT', this.customerForm.value,'Customers', errMessage).subscribe(
            res => {
              if(res.Error){
                this.log.error('Error sending debug email for customer page: ' + res.Message)
              }else {
                this.log.debug('Debug email sent to support from the customer page.')
              }
            }, err => {
              this.log.error('Application error sending debug email: ' + err.toString() );
            });

          this.log.error(this.data.loggedIn + ' encountered an error creating a customer: Submitted data: ' + '{' + this.customerForm.value.toString() + '} ' + res.Message.toString() );
        }else {

            this.log.info(this.data.loggedIn + ' added a customer ' + this.customerForm.get('customer_name').value.trim()  );

            if (this.customerForm.get('modeling').value) {
              this.messager.openSnackBar('Modeling jobs created for ' + this.customerForm.get('customer_name').value.trim(), '', 'successAlert');
            }

        }

    },
      err => {
      this.log.error(this.data.loggedIn + ' encountered an error creating a customer: Submitted data: ' + '{' + this.customerForm.value.toString() + '} ' + err.toString() );
    }
    );
  }




}

@Component({
  selector: 'app-customers',
  templateUrl: './customers.component.html',
  styleUrls: ['./customers.component.css']
})
export class CustomersComponent implements OnInit {

  public configuration: Config;
  public columns: Columns[];
  editData;

  modal = false;
  selected;

  faedit = faEdit;
  // Card 6TSzF61V: this button deactivates rather than deletes, so it wears a ban icon.
  fadeactivate = faBan;
  faplussquare = faPlusSquare;

  activeCustomerToggle = false;
  filterActiveCustomer$: Observable<Customer[]>;
  gridEntrie$: Observable<Customer[]>;
  displayedColumns: string[] = ['customer_name', 'billing_notes', 'customer_note'];
  user;
  usernamee;
  socket : any;
  private baseURL = environment.baseUrl;

  constructor(public customerService: CustomerService, public dialog: MatDialog, public auth: AuthService, public log: LoggingService, private messager: MessagerComponent) {

        this.socket = io(this.baseURL);

   }

  ngOnInit(): void {

    this.customerService.init();

    this.configuration = {...DefaultConfig};
    this.configuration.tableLayout.theme = 'lIGHT';
    this.configuration.tableLayout.style = 'big';
    this.configuration.tableLayout.borderless = false;
    this.configuration.tableLayout.hover = true;
    this.configuration.searchEnabled = true;
    this.configuration.paginationEnabled = true;
    this.configuration.paginationRangeEnabled = false;
    this.configuration.isLoading = true;
    this.configuration.rows = 100;

    this.gridEntrie$ = this.customerService.getInitial().pipe(
      map(customers => customers.map(c => ({
        ...c,
        location: `${c.office_street_address || ''} ${c.office_city || ''},${c.office_state || ''},${c.office_zip || ''}`
      }))),
      tap(() => {
        this.configuration.isLoading = this.customerService.isLoading;
      })
    );

    // Card 6TSzF61V: the grid renders the filtered stream; the toggle starts OFF so a
    // freshly deactivated customer visibly turns pink instead of vanishing.
    this.filterActiveCustomer$ = this.gridEntrie$;

    this.columns = [
      { key: '', title: '', searchEnabled: false, width: '40px'},
      { key: 'customer_name', title: 'Customer Name' },
      { key: 'billing_notes', title: 'Billing Notes' },
      { key: 'location', title: 'Location'}, 
      { key: 'customer_note', title: 'Customer Note' },
    ]

    this.auth.userProfile$.subscribe(
      (profile) => {
        this.user = profile;
        this.usernamee = this.user ? this.user.nickname.charAt(0).toUpperCase() + this.user.nickname.slice(1) : '';
    });

    this.socket.on('newCustomer', data => {
      this.customerService.addOneFrontend(data.newOne);
    });

  }

  // Card 6TSzF61V: mirrors filterActiveJobs() on the Customer Jobs grid. Uses a truthiness
  // test rather than `=== false` so a null flag can never hide an active customer.
  filterActiveCustomers(): void {
    this.activeCustomerToggle = !this.activeCustomerToggle;
    if (this.activeCustomerToggle) {
      this.filterActiveCustomer$ = this.gridEntrie$.pipe(
        map((customers) => customers.filter((c) => !c.inactivecustomer))
      );
    } else {
      // Reset to the original list
      this.filterActiveCustomer$ = this.gridEntrie$;
    }
  }

  openAdditionalWorkDialog(row){

    const dialogConfig = {
      data: {
        location_id: -1,
        job_id: -1,
        customer_id : row.customer_id
      },
      width: '500px',
      height: '80vh'
    }

    const dialogRef = this.dialog.open(AdditionalworkComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(result => {
        if (result === 1) {
          this.messager.openSnackBar('Additional work added!', '', 'successAlert');
        }else {
        }
      });

  }


  openDialog(myData): void {

    this.customerService.getOneCustomer(myData.customer_id).subscribe(
      (tdata: any) => {
        const dialogRef = this.dialog.open(EditCustomerDialogComponent, {
          height: '80vw',
          width: '70vw',
          data: {
            customer_id : tdata.Customer.customer_id,
            customer_name : tdata.Customer.customer_name,
            office_street_address : tdata.Customer.office_street_address,
            office_city : tdata.Customer.office_city,
            office_state : tdata.Customer.office_state,
            planroom_web_address : tdata.Customer.planroom_web_address,
            planroom_username_login : tdata.Customer.planroom_username_login,
            certificates_go_to : tdata.Customer.certificates_go_to,
            customer_note : tdata.Customer.customer_note,
            needsplanrev : tdata.Customer.needsplanrev,
            inactivecustomer : tdata.Customer.inactivecustomer,
            region : tdata.Customer.region,
            office_zip : tdata.Customer.office_zip,
            customer_type : tdata.Customer.customer_type,
            dsecuritygroup : tdata.Customer.dsecuritygroup,
            dsalesman : tdata.Customer.dsalesman,
            ratercompid : tdata.Customer.ratercompid,
            folderlocation : tdata.Customer.folderlocation,
            qad_id : tdata.Customer.qad_id,
            designeremail : tdata.Customer.designeremail,
            licenseno : tdata.Customer.licenseno,
            billing_notes : tdata.Customer.billing_notes,
            billing_type : tdata.Customer.billing_type,
            referral : tdata.Customer.referral,
            codecomp : tdata.Customer.codecomp,
            customurl : tdata.Customer.customurl,
            doc_url : tdata.Customer.doc_url,
            startscoord : tdata.Customer.startscoord,
            billcontact : tdata.Customer.billcontact,
            purchasing : tdata.Customer.purchasing,
            refpaid : tdata.Customer.refpaid,
            welcome : tdata.Customer.welcome,
            creferral : tdata.Customer.creferral,
            planpath : tdata.Customer.planpath,
            sendrevcon : tdata.Customer.sendrevcon,
            paymenthold : tdata.Customer.paymenthold,
            inv_delivery_mtd : tdata.Customer.inv_delivery_mtd,
            pmt_recon_mtd : tdata.Customer.pmt_recon_mtd,
            po_system : tdata.Customer.po_system,
            account_manager: tdata.Customer.account_manager,
            accounting_rep: tdata.Customer.accounting_rep,
            hers_modeler : tdata.Customer.hers_modeler,
            registry_name : tdata.Customer.registry_name,
            reviewer : tdata.Customer.reviewer,
            tier : tdata.Customer.tier,
            mode: 1,
            usernamee : this.usernamee
          },
          panelClass: 'edit-dialog-container'
        });

        dialogRef.afterClosed().subscribe(result => {
          this.editData = result;
        });


      }
    )


  }

  addCustomerDialog() : void {
    const dialogref = this.dialog.open(
      EditCustomerDialogComponent, {
        width: '55vw',
        height: '80vh',
        data: {
          mode: 2,
          usernamee : this.usernamee
        },
        panelClass: 'edit-dialog-container'
      });
  }

  deleteCustomerDialog(customer): void {

    const dialogRef = this.dialog.open(GridDeleteComponent, {
      width: '500px',
      data: {
        delete_body_text: 'Are you sure you want to make ' + customer.customer_name + ' inactive?',
        delete_api_url: '/rhAPI/customers/delete/',
        delete_id: customer.customer_id,
        delete_header_text: 'Deactivating ' + customer.customer_name
      },
      panelClass: 'edit-dialog-container'
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 1){
        this.customerService.deleteCustomer(customer.customer_id);
        this.log.info(this.usernamee + ' marked the customer inactive: ' + customer.customer_name + ' id: ' + customer.customer_id);
      }
    });

  }

}
